import { Component, Output, EventEmitter, Input, OnChanges, SimpleChanges, ViewChild, ElementRef } from "@angular/core";
import { Observable, of } from "rxjs";
import { debounceTime, distinctUntilChanged, switchMap, catchError } from "rxjs/operators";
import { NgbTypeahead } from "@ng-bootstrap/ng-bootstrap";
import { Location } from "../../../core/core";
import { Address } from "../../../core/models/address.model";
import { JsonLocationSearchService, JsonLocationResult } from "../../../core/services/json-location-search.service";

@Component({
  selector: "app-global-search-bar-location",
  templateUrl: "./global-search-bar-location.component.html",
  styleUrls: ["./global-search-bar-location.component.scss"],
})
export class GlobalSearchBarLocationComponent implements OnChanges {
  @ViewChild("instance") instance: NgbTypeahead;
  @ViewChild("locationInput") locationInput: ElementRef;

  @Input() location: Location;
  @Output() locationSelected = new EventEmitter<Location>();

  model: any;
  availableLocations: JsonLocationResult[] = [];

  constructor(private jsonLocationService: JsonLocationSearchService) { }

  ngOnChanges(changes: SimpleChanges): void {
    const locationCurrentValue = changes.location?.currentValue as Location;
    if (!locationCurrentValue?.latitude || !locationCurrentValue?.longitude) {
      if (changes.location?.previousValue != null) {
        this.model = null;
      }
      return;
    }

    if (locationCurrentValue.address != null) {
      this.model = {
        address: {
          freeformAddress: `${locationCurrentValue.address.city}, ${locationCurrentValue.address.stateProvince}`,
        },
        position: {
          lat: locationCurrentValue.latitude,
          lon: locationCurrentValue.longitude,
        },
      };
    }
  }

  formatter = (result: JsonLocationResult) => result?.address?.freeformAddress || "";

  search = (text$: Observable<string>) => {
    return text$.pipe(
      debounceTime(300),
      distinctUntilChanged(),
      switchMap(term => {
        if (!term || term.length < 2) {
          return of([]);
        }
        return this.jsonLocationService.searchLocations(term).pipe(
          catchError(() => of([]))
        );
      })
    );
  };

  onSelectItem(event: any) {
    const selected = event.item as JsonLocationResult;
    if (!selected?.position?.lat || !selected?.position?.lon) {
      return;
    }

    const address = {
      city: selected.address.postalName || selected.address.localName || selected.address.municipality || "",
      stateProvince: selected.address.countrySubdivision || "",
      postalCode: selected.address.postalCode || "",
      countryCode: selected.address.countryCode || "",
    } as Address;

    const location = {
      latitude: selected.position.lat,
      longitude: selected.position.lon,
      address,
    } as Location;

    this.locationSelected.emit(location);
  }

  onBlur() {
    if (this.model !== undefined && !this.model) {
      this.locationSelected.emit(null);
    }
  }
}
